<template>
  <section>
    <template v-if="startEndDates">
      <div class="flex">
        <div class="w-1/2 pr-4 cursor-pointer">
          <div @click="ui.showStartDatePicker = true">
            <div class="font-label">Start Date</div>
            <div class="font-sans bg-surface-primary w-full pl-2 h-8 leading-8">
              {{ startDate }}
            </div>
          </div>
          <OnClickOutside @trigger="ui.showStartDatePicker = false">
            <div v-if="ui.showStartDatePicker" class="absolute z-10">
              <DatePicker :selectedDate="startDate" @datePickerChange="startDatePickerChange" />
            </div>
          </OnClickOutside>
        </div>
        <div class="w-1/2 cursor-pointer">
          <div @click="ui.showEndDatePicker = true">
            <div class="font-label">End Date</div>
            <div class="font-sans bg-surface-primary w-full pl-2 h-8 leading-8">{{ endDate }}</div>
          </div>
          <OnClickOutside @trigger="ui.showEndDatePicker = false">
            <div v-if="ui.showEndDatePicker" class="absolute z-10 right-0">
              <DatePicker :selectedDate="endDate" @datePickerChange="endDatePickerChange" />
            </div>
          </OnClickOutside>
        </div>
      </div>
    </template>
    <div class="flex mt-2">
      <div class="w-1/2">
        <div v-for="(item, key) in reportTypes" :key="key">
          <RadioInput
            :id="key"
            :uid="item.uid"
            v-model="reportType"
            :value="item.value"
            :label="item.label"
            :radioName="`${item.uid}ReportExport`"
          />
        </div>
      </div>
      <div class="w-1/2">
        <ButtonDefault :id="`${uid}-export-button`" @click="onSubmit" label="Export" />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { OnClickOutside } from '@vueuse/components'
import moment from 'moment'
import { PropType, defineComponent } from 'vue'

import ButtonDefault from '@/common/components/atoms/ButtonDefault.vue'
import RadioInput from '@/common/components/molecules/RadioInput.vue'
import DatePicker from '@/common/components/organisms/DatePicker.vue'
import loc from '@/utils/loc'

interface ExportFields {
  uid: string
  label: string
  value: string
}

export default defineComponent({
  name: 'ExportForm',
  components: {
    ButtonDefault,
    DatePicker,
    OnClickOutside,
    RadioInput,
  },
  props: {
    uid: {
      type: String,
      required: true,
    },
    baseUrl: {
      type: String,
      required: true,
    },
    reportTypes: {
      type: Object as PropType<Record<string, ExportFields>>,
      required: true,
    },
    startEndDates: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    let today = moment()
    return {
      reportType: 'byShowDate',
      startDate: today.clone().startOf('month').format('yyyy-MM-DD') as string,
      endDate: today.clone().format('yyyy-MM-DD') as string,
      ui: {
        showStartDatePicker: false,
        showEndDatePicker: false,
      },
    }
  },

  methods: {
    onSubmit() {
      if (this.reportType == 'byBooking') {
        return loc.redirect(`${this.baseUrl}?start_date=${this.startDate}&end_date=${this.endDate}`)
      } else if (this.reportType == 'byShowDate') {
        return loc.redirect(
          `${this.baseUrl}?show_start_date=${this.startDate}&show_end_date=${this.endDate}`,
        )
      } else if (this.reportType == 'bySubscribed') {
        return loc.redirect(`${this.baseUrl}?accepts_marketing=true`)
      } else {
        return loc.redirect(`${this.baseUrl}?no_accepts_marketing=true`)
      }
    },

    startDatePickerChange(dateObj: { date: string }) {
      this.startDate = dateObj.date
      this.ui.showStartDatePicker = false
    },

    endDatePickerChange(dateObj: { date: string }) {
      this.endDate = dateObj.date
      this.ui.showEndDatePicker = false
    },
  },
})
</script>
